export default {"src":"/_next/static/media/SmileyXEyes.88bbc429.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};